import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Modal } from "../shared-components/Modal";

type Skipped = { url: string; text?: string; reason?: string };
type Props = { skippedPosts: Skipped[] | undefined };

export const ManualScrapeSkippedPostsModal = ({ skippedPosts }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  function close() {
    setIsOpen(false);
  }
  function show() {
    setIsOpen(true);
  }
  if (!skippedPosts || skippedPosts.length === 0) return null;
  return (
    <div>
      <div
        className="flex gap-1 ml-2 px-2 py-1 text-yellow-900 bg-yellow-200 rounded-xl cursor-pointer"
        onClick={show}
        title="View skipped posts"
      >
        <ExclamationCircleIcon className="w-5" />
        {skippedPosts.length.toString()}
      </div>
      <Modal open={isOpen} onClose={close} title={""} width={"w-5/6"}>
        <div>
          <h2 className="text-xl pb-3">
            Skipped Posts: {skippedPosts.length.toString()}
          </h2>
          <p className="text-sm text-yellow-700 pb-3">
            These posts were skipped because they appear to belong to a
            different profile than the one currently in progress.
          </p>
          {skippedPosts.map((post, idx) => (
            <div
              key={`${post.url}-${idx}`}
              className="w-full pb-3 overflow-auto"
            >
              <div className="w-full flex items-center">
                <div className="truncate">{post.text}</div>
              </div>
              <div className="w-full flex items-center">
                <span className="w-1/2 truncate">
                  <a
                    href={post.url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-xs text-blue-500 decoration-transparent"
                  >
                    {post.url}
                  </a>
                </span>
              </div>
              {post.reason && (
                <span className="text-xs text-gray-500">
                  Reason: {post.reason}
                </span>
              )}
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
};
